/* eslint-disable no-console */
export function toString(json: any, defaultValue: any) {
  let result = defaultValue;
  try {
    result = JSON.stringify(json);
  } catch (e) {
    console.error('can not convert to string', json, e);
  }
  return result;
}

export function toJson(str: string, defaultValue: any) {
  let result = defaultValue;
  try {
    result = JSON.parse(str);
  } catch (e) {
    console.error('can not convert to json', str, e);
  }
  return result;
}
